"use client";

import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'GEO和SEO有什么区别？为什么现在需要关注GEO？',
      answer: 'SEO针对传统搜索引擎（如谷歌、百度）优化，目标是提高网站排名。GEO则针对AI助手（deepSeek、豆包、元宝、文心一言、通义千问）优化，目标是让您的品牌在AI对话中被优先引用和推荐。随着越来越多用户使用AI助手获取信息，GEO成为品牌获取流量的新关键。数据显示，2024年AI搜索的使用率已增长超200%，提前布局GEO将帮助您抢占AI时代的流量红利。'
    },
    {
      question: '你们的GEO优化服务包含哪些内容？',
      answer: '我们提供全链路GEO优化解决方案：（1）智能诊断：通过可见度、场景问题数等数据，直观判断品牌在AI平台的表现，支持多平台监测与竞品对比；（2）内容优化：基于AI模型偏好重构内容表达，构建企业知识图谱，让AI更容易理解和引用；（3）全域分发：智能匹配自媒体、行业垂直媒体、权威综合门户，一键触达高权重媒体；（4）持续监测：实时追踪效果，AI自我学习反哺优化策略。'
    },
    {
      question: '我的企业适合做GEO优化吗？',
      answer: '几乎所有需要线上获客的企业都适合GEO优化，特别是：（1）B2B企业：用户决策时会咨询AI，品牌在AI对话中的可见度直接影响商机；（2）本地服务商：用户通过AI搜索"附近的XX"，GEO让您优先被推荐；（3）电商品牌：AI购物助手兴起，品牌需要在AI推荐中占据位置；（4）知识付费/教育培训：用户咨询AI学习建议时，您的课程能被优先提及；（5）专业服务（法律、医疗、咨询等）：建立AI认可的专业权威性。'
    },
    {
      question: '你们支持哪些AI平台？会持续更新吗？',
      answer: '目前我们的优化服务覆盖主流AI平台包括：deepSeek、豆包、元宝、文心一言（百度）、通义千问（阿里）、Kimi、智谱清言等10余个平台。我们持续跟踪AI技术发展，定期更新优化策略以适配新兴AI平台。合作期间，您将自动享受我们对新平台的支持和策略升级服务。'
    },
    {
      question: 'GEO优化效果需要多久能看到？',
      answer: 'GEO效果呈现有一定周期性，通常：（1）优化启动后1-2周，AI平台开始索引和识别优化内容；（2）1-2个月后，品牌在AI对话中的可见度开始提升，场景问题数增加；（3）3-6个月达到稳定效果，持续获得AI流量。效果速度取决于行业竞争度、内容基础、优化深度等因素。我们的AI自我学习机制会持续优化策略，效果会越来越好。'
    },
    {
      question: '如何衡量GEO优化的效果？',
      answer: '我们提供多维度的效果评估指标：（1）可见度趋势：品牌在各AI平台的可见度变化曲线；（2）场景问题数：品牌被AI引用回答的问题数量；（3）信源分析：品牌内容被哪些渠道引用，权重如何；（4）竞品对比：与竞争对手的可见度对比；（5）流量转化：来自AI平台的实际访问量和转化数据。我们会提供定期数据报告，让效果清晰可见。'
    },
    {
      question: '你们的服务如何收费？合作方式灵活吗？',
      answer: '我们提供灵活的合作方式：（1）平台选择：可选择单平台或多平台优化；（2）合作周期：支持季度、半年、年度合作，有效果后再续费；（3）服务范围：可选择全链路解决方案，也可以选择单点服务（如仅诊断监测、仅内容优化等）；（4）定制方案：根据企业规模、行业特点、预算情况提供定制化方案。具体报价需要根据您的需求评估，欢迎咨询获取专属方案。'
    },
    {
      question: '数据安全如何保障？',
      answer: '数据安全是我们的重点：（1）保密协议：签署严格的商业保密协议，保护企业信息；（2）数据隔离：每个客户的数据独立存储，权限严格管控；（3）合规运营：符合数据安全法规要求，通过安全认证；（4）透明可控：您可以随时查看数据使用情况，拥有数据的完全知情权。我们承诺不会将您的数据用于其他用途或泄露给第三方。'
    },
    {
      question: 'GEO市场前景如何？现在入局晚不晚？',
      answer: '现在正是最佳入局时机：（1）市场处于早期阶段，大部分企业对GEO认知有限，竞争小；（2）AI搜索使用率快速增长，用户习惯正在形成，需求端在爆发；（3）先行者可以建立品牌在AI平台的权威性壁垒，占据先发优势；（4）AI技术持续进化，GEO的重要性会越来越高。参考SEO行业的发展历程，早期布局者都获得了巨大红利。GEO市场规模预计在未来3-5年将增长10倍以上。'
    },
    {
      question: '我已经在做SEO，GEO会取代SEO吗？',
      answer: 'GEO不会完全取代SEO，而是对SEO的补充和升级。两者可以并行：（1）传统搜索引擎仍有大量用户，SEO依然重要；（2）GEO覆盖AI搜索用户，是新的流量增长点；（3）两者结合能实现全渠道流量覆盖，最大化品牌曝光；（4）GEO优化的内容（结构化、权威性）对SEO也有正向作用。建议将GEO作为营销升级方向，打造"SEO+GEO"的全方位流量获取体系。'
    }
  ];

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-purple-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl mb-6">常见问题解答</h2>
          <p className="text-xl text-gray-600">
            关于GEO优化服务的常见疑问，为您一一解答
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex justify-between items-start gap-4 hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg pr-4">{faq.question}</span>
                <ChevronDown
                  size={24}
                  className={`flex-shrink-0 text-blue-600 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-blue-600 to-purple-600 p-8 rounded-2xl text-white text-center">
          <h3 className="text-2xl mb-3">还有其他问题？</h3>
          <p className="mb-6">
            欢迎联系我们的顾问团队，我们将为您提供详细解答和专业建议
          </p>
          <a
            href="#contact"
            className="inline-block bg-white text-blue-600 px-8 py-3 rounded-lg hover:shadow-lg transition-shadow"
          >
            立即咨询
          </a>
        </div>
      </div>
    </section>
  );
}
